export default __webpack_public_path__ + "e535bd9.png";